import "./App.css";
import Login from "./Pages/Login/Login";
import ForgotPassword from "./Pages/Login/ForgetPassword";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./Pages/Home";
import OtpPage from "./Pages/Login/OtpPage";
import CampaignPage from "./Pages/CampaignPage/CampaignPage";
import OnboardingPage from "./Pages/OnboardingPage/OnboardingPage";
import RedirectEmarati from "./Pages/RedirectEmarati/RedirectEmarati";
import PrivacyPolicy from "./Pages/Legal/PrivacyPolicy";
import TermsOfUse from "./Pages/Legal/TermsOfUse";
import RegisterPage from "./Pages/RegisterPage/RegisterPage";
import EmployerPage from "./Pages/HomePage/EmployerPage";
import Jobseeker from "./Pages/Jobseeker/Jobseeker";
import Signup from "./Pages/Signup/Signup";
import FAQ from "./Pages/FAQ/FAQ";
import Verified from "./Pages/Verified/Verified";
import UAEPassRedirect from "./Components/UAEPassRedirect/UAEPassRedirect";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/*" element={<Home />} />
          <Route path="/" element={<EmployerPage />} />
          <Route path="/jobseeker" element={<Jobseeker />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/campaign" element={<CampaignPage />} />
          <Route path="/onboard" element={<OnboardingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verified" element={<Verified />} />
          <Route path="/forgetPassword" element={<ForgotPassword />} />
          <Route path="/OtpPage" element={<OtpPage />} />
          <Route path="/redirect" element={<RedirectEmarati />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/uaepass/auth/callback" element={<UAEPassRedirect />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
